module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am5_en.881d4e9bb2aa06d1ced866c1e634b9f6.png";